import { Component, Input, OnInit } from '@angular/core';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';

@Component({
    selector: 'sn-usc-view-desc-bubble',
    templateUrl: './usc-view-desc-bubble.component.html',
    styleUrls: ['./usc-view-desc-bubble.component.css']
})
export class UscViewDescBubbleComponent implements OnInit {
    @Input() view;

    constructor(
        public uscStoreService: UscStoreService,
    ) { }

    ngOnInit() {
    }

    isCustomViewDescriptionEnabled(view): boolean {
        return this.uscStoreService.isCustomViewDescriptionEnabled(view);
    }

    getCustomViewDescription(view): string {
        return this.uscStoreService.getCustomViewDescription(view);
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-view-desc-bubble/usc-view-desc-bubble.component.ts